import { Grid, useMediaQuery, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { SectionHeader, CountUpNumber } from '@/src/components/molecules';

const useStyles = makeStyles(theme => ({
  placementGrid: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
    },
  },
  placementGridItemMiddle: {
    margin: theme.spacing(0, 6),
  },
}));

const Locations = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid container spacing={1} data-aos="fade-up">
        <Grid item xs={12}>
          <SectionHeader
            label="Nossos números"
            title={
              <span>
                <Typography color="secondary" variant="inherit" component="span">
                  Mais de 300 parceiros{' '}
                </Typography>
                em todo o Brasil
              </span>
            }
            subtitle="Nosso ecossistema de soluções para instituições educacionais, fornecedores e 
            consumidores em educação está presente em todas as regiões do país."
            fadeUp
            disableGutter
            align={isMd ? 'center' : 'left'}
          />
        </Grid>
        <Grid item xs={12}>
          <div className={classes.placementGrid}>
            <div>
              <CountUpNumber
                prefix="+"
                start={0}
                end={150}
                label="Fornecedores educacionais"
                textColor="secondary"
              />
            </div>
            <div className={classes.placementGridItemMiddle}>
              <CountUpNumber
                prefix="+"
                start={0}
                end={1100}
                label="Instituições de ensino"
                textColor="secondary"
              />
            </div>
            <div>
              <CountUpNumber
                prefix="+"
                start={0}
                end={500000}
                label="Famílias"
                textColor="secondary"
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

Locations.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Locations;
